<template>
  <div id="top-header">
    <dv-decoration-8 class="header-left-decoration" style="width: 35%"/>
    <!--    <dv-decoration-2 class="header-center-decoration" />-->
    <dv-decoration-8 class="header-right-decoration" style="width: 35%" :reverse="true"/>
    <div class="center-title">{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: 'TopHeader',
  data() {
    return {
      title: '众创大数据'
    }
  },
  mounted() {
    function getQueryString(name) {
      let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i') // 正则语句
      let r = window.location.search.substr(1).match(reg) // 获取url的参数部分，用正则匹配
      if (r != null) {
        return decodeURIComponent(r[2]) // 解码得到的擦拭农户
      }
      return null
    }

    const n = getQueryString('name')
    if (n) {
      this.title = n
      document.title = n
    } else {
      document.title = ''
    }
  }
}
</script>

<style lang="less">
#top-header {
  position: relative;
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;

  .header-center-decoration {
    width: 40%;
    height: 80px;
    margin-top: 30px;
  }

  .header-left-decoration, .header-right-decoration {
    width: 35%;
    height: 80px;
  }

  .center-title {
    position: absolute;
    font-size: 80px;
    font-weight: bold;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
  }
}

@media screen and (max-width: 2000px) {
  #top-header {
    position: relative;
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: space-between;
    flex-shrink: 0;

    .header-center-decoration {
      width: 40%;
      height: 48px;
      margin-top: 18px;
    }

    .header-left-decoration, .header-right-decoration {
      width: 35%;
      height: 48px;
    }

    .center-title {
      position: absolute;
      font-size: 48px;
      font-weight: bold;
      left: 50%;
      top: 0;
      transform: translateX(-50%);
    }
  }

  @media screen and (max-width: 1700px) {
    #top-header {
      position: relative;
      width: 100%;
      height: 51px;
      display: flex;
      justify-content: space-between;
      flex-shrink: 0;

      .header-center-decoration {
        width: 40%;
        height: 35px;
        margin-top: 15px;
      }

      .header-left-decoration, .header-right-decoration {
        width: 35%;
        height: 35px;
      }

      .center-title {
        position: absolute;
        font-size: 35px;
        font-weight: bold;
        left: 50%;
        top: 0;
        transform: translateX(-50%);
      }
    }
  }
}
</style>
